export const BidStrategy = {
  ManualCpc: 1,
  EnhancedCpc: 5,
  ManualCpv: 11,
  ManualCpm: 12,
};

export const BiddingStrategyToPricingModel = {
  ManualCpc: 'CPC',
  ManualCpv: 'CPV',
  ManualCpm: 'CPM',
};

export const BiddingStrategyToBidParam = {
  ManualCpc: 'SearchBid',
  EnhancedCpc: 'SearchBid',
  ManualCpv: 'CpvBid',
  ManualCpm: 'CpmBid',
};

export const BiddingStrategyValueToBidParam = {
  1: 'SearchBid',
  5: 'SearchBid',
  11: 'CpvBid',
  12: 'CpmBid',
};

export const PricingModelToBidParam = {
  CPC: 'SearchBid',
  CPV: 'CpvBid',
  CPM: 'CpmBid',
};

export const BiddingStrategyToRangeKey = {
  ManualCpc: 'KeywordBidRange',
  EnhancedCpc: 'KeywordBidRange',
  ManualCpv: 'KeywordCPVBidRange',
  ManualCpm: 'KeywordCPMBidRange',
};

export const BiddingStrategyValueToRecommendBidKey = {
  ManualCpc: 'RecommendCPCBid',
  EnhancedCpc: 'RecommendCPCBid',
};

export const PricingModelToRangeKey = {
  CPC: 'KeywordBidRange',
  CPV: 'KeywordCPVBidRange',
  CPM: 'KeywordCPMBidRange',
};
